/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetCrosshairIcon16Regular = forwardRef('TargetCrosshairIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.004a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm1.551-.754A5.503 5.503 0 0 1 7.25 2.555V4.75a.75.75 0 0 0 1.5 0V2.555a5.503 5.503 0 0 1 4.699 4.695H11.25a.75.75 0 0 0 0 1.5h2.2a5.503 5.503 0 0 1-4.7 4.704V11.25a.75.75 0 0 0-1.5 0v2.204a5.503 5.503 0 0 1-4.7-4.704h2.2a.75.75 0 0 0 0-1.5H2.551Z" })));
});
